import '@assets/styles/pages/site-summary-all-details.scss';
import { ReactElement } from 'react';
import { SiteSummaryPageDetails } from '@components/siteSummaryDetails';

export const SiteLeadAllDetails = (): ReactElement => {
	return <SiteSummaryPageDetails />;
};
